import { AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
  output,
} from '@angular/core';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';

@Component({
  selector: 'currency',
  templateUrl: './currency.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CurrencyformatPipe, AsyncPipe, NgClass],
})
export class CurrencyComponent implements OnInit {
  private readonly cd = inject(ChangeDetectorRef);

  columnData: Observable<any> = new BehaviorSubject(null);
  keyName: Observable<any> = new BehaviorSubject(null);
  isClickable: Observable<any> = new BehaviorSubject(false);
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output<{ action: string; columnData: any }>();

  vm$ = new BehaviorSubject<{
    row: Record<string, unknown>;
    keyname: string;
    isClickable: boolean;
    convertFromMinorCurrency: boolean;
  } | null>(null);

  ngOnInit(): void {
    combineLatest([
      this.columnData,
      this.keyName,
      this.isClickable,
      this.additionData,
    ])
      .pipe(
        map(([row, keyname, isClickable, extra]) => {
          if (!row || !keyname) {
            return null;
          }

          return {
            row,
            keyname,
            isClickable: !!isClickable,
            convertFromMinorCurrency: extra?.convertFromMinorCurrency ?? true,
          };
        }),
      )
      .subscribe((value) => {
        this.vm$.next(value);
        this.cd.markForCheck();
      });
  }

  openWriteOffModal(action: string, columnData: Record<string, unknown>): void {
    this.onAction.emit({ action, columnData });
  }
}
